export default "__VITE_ASSET__Br9Uco9j__"